// src/hooks/useFormComponents.tsx
import { DateTimePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { isValidDateValue } from "../utils/typeGuards";

/**
 * 編集可能な日付フィールドをレンダリングするためのカスタムフック
 */
export const useFormComponents = (isEditing: boolean) => {
    /**
     * 編集可能な日付フィールドをレンダリングする
     * @param value 日付の値
     * @param onChange 値が変更されたときのコールバック
     * @returns 編集モードではDateTimePickerコンポーネント、表示モードでは整形された日付文字列
     */
    const renderEditableDate = (
        value: string | number | null | undefined,
        onChange: (date: string | null) => void
    ) => {
        if (isEditing) {
            // 表示用の値を適切に処理
            const dateValue = isValidDateValue(value) ? dayjs(value) : null;
            return (
                <DateTimePicker
                    value={dateValue}
                    onChange={(newDate) => {
                        if (newDate) {
                            // ローカル時刻としてフォーマット
                            const jstDateString = newDate.format('YYYY-MM-DDTHH:mm:ss');
                            onChange(jstDateString);
                        } else {
                            onChange(null);
                        }
                    }}
                    ampm={false}
                    format="YYYY/MM/DD HH:mm"
                    slotProps={{ textField: { size: 'small' } }}
                />
            );
        }
        // 表示時の形式は変更なし
        return isValidDateValue(value) ? dayjs(value).format('YYYY/MM/DD HH:mm') : '-';
    };

    return {
        renderEditableDate,
    };
};